import {permissionsEnabled} from '@netx/core-permissions-next/enablers';
import {currentUserIsAdmin} from '@netx/core-permissions-next/enablers/currentUserIsAdmin';
import permissions from '@netx/core-permissions/properties/permissions';
import {i18n} from '@netx/core-locales';
import {notMobile} from '@netx/core/lib/netx-enablers';

const permissionsV2Enabled = permissionsEnabled();

export let constituents = {
	types: {
		1: 'keyframe',
		2: 'layer',
		3: 'page',
		4: 'clip',
	},
	typeNames: {
		1: 'i18n.consituentsKeyframes',
		2: 'i18n.consituentsLayers',
		3: 'i18n.consituentsPages',
		4: 'i18n.consituentsClips',
	},
};

export let dragUserLevel = 8;

// Tasks that run on assets at import
export let importTasks = {
	AudioTask: i18n.t('i18n.performingTaskAudio'),
	FFFViewTask: i18n.t('i18n.performingTaskFFFView'),
	INDDPageTask: i18n.t('i18n.performingTaskINDDPage'),
	IWorkPageTask: i18n.t('i18n.performingTaskIWorkPage'),
	KeyframesTask: i18n.t('i18n.performingTaskKeyframes'),
	MetadataTask: i18n.t('i18n.performingTaskMetadata'),
	OfficePageTask: i18n.t('i18n.performingTaskOfficePage'),
	PDFPageTask: i18n.t('i18n.performingTaskPDFPage'),
	PostImportTask: i18n.t('i18n.performingTaskPostImport'),
	PreviewTask: i18n.t('i18n.performingTaskPreview'),
	RelatedAssetTask: i18n.t('i18n.performingTaskRelatedAssets'),
	SWFTask: i18n.t('i18n.performingTaskSWF'),
	ThumbnailTask: i18n.t('i18n.performingTaskThumbnail'),
	VideoPreviewTask: i18n.t('i18n.performingTaskVideoPeview'),
	WatermarkTask: i18n.t('i18n.performingTaskWatermark'),
	ZoomTask: i18n.t('i18n.performingTaskZoom'),
};

export let renderableChanges = [
	'attributeIds',
	'attributeNames',
	'attributeValues',
	'checkout',
	'creationdate',
	'expirationDate',
	'file',
	'fileSize2',
	'fileheight',
	'filesize',
	'filetype',
	'filetypelabel',
	'filewidth',
	'geoLocationLabel',
	'imageid',
	'importDate',
	'locationContext',
	'locationid',
	'moddate',
	'moduserid',
	'moduserlabel',
	'name',
	'path',
	'permissionMatrix',
	'previewHeight',
	'previewUrl',
	'previewWidth',
	'readOnly',
	'repurposeAvailability',
	'status',
	'thumb',
	'thumbUrl',
	'versionIds',
	'viewIds',
	'viewNames',
	'zoomAvailable',
];

export let status = {
	UNKNOWN: 0,
	ONLINE: 1,
	NEARLINE: 2,
	OFFLINE: 3,
	TEMP: 4,
	CHECKOUT: 5,
	IMPORT_IN_PROGRESS: 6,
};

export let things = {
	attributeHistory: {
		label: i18n.t('i18n.attributeHistory'),
		matrix: permissionsV2Enabled ? 'modify' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 4,
		enableTest: notMobile,
	},
	attributes: {
		label: i18n.t('i18n.attributes'),
	},
	categories: {
		label: i18n.t('i18n.categories'),
		matrix: permissionsV2Enabled ? 'download' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 2,
	},
	clips: {
		label: i18n.t('i18n.constituentsClips'),
		userLevel: permissionsV2Enabled ? undefined : 2,
	},
	constituents_keyframes: {
		label: i18n.t('i18n.constituentsKeyframes'),
		matrix: permissionsV2Enabled ? 'modify' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 7,
	},
	constituents_layers: {
		label: i18n.t('i18n.constituentsLayers'),
		matrix: permissionsV2Enabled ? 'modify' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 7,
	},
	constituents_pages: {
		label: i18n.t('i18n.constituentsPages'),
		matrix: permissionsV2Enabled ? 'modify' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 7,
	},
	detail: {
		label: i18n.t('i18n.detail'),
		matrix: 'read',
		userLevel: permissionsV2Enabled ? undefined : 2,
	},
	fileinfo: {
		label: i18n.t('i18n.fileinfo'),
	},
	index: {
		label: i18n.t('i18n.index'),
		userLevel: 9,
	},
	links: {
		label: i18n.t('i18n.links'),
		userLevel: permissionsV2Enabled ? undefined : 2,
	},
	metadata: {
		label: i18n.t('i18n.metadata'),
		matrix: permissionsV2Enabled ? 'download' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 2,
	},
	overview: {
		label: i18n.t('i18n.overview'),
		matrix: permissionsV2Enabled ? 'download' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 2,
	},
	permissions: {
		label: i18n.t('i18n.permissions'),
		userLevel: permissionsV2Enabled ? 9 : 8,
	},
	preview: {
		label: i18n.t('i18n.preview'),
	},
	projects: {
		label: i18n.t('i18n.projects'),
		enableTest: notMobile,
	},
	reviews: {
		label: i18n.t('i18n.reviews'),
		enableTest: notMobile,
	},
	usage: {
		label: i18n.t('i18n.usage'),
		matrix: permissionsV2Enabled ? 'modify' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 7,
	},
	versions: {
		label: i18n.t('i18n.versions'),
		matrix: permissionsV2Enabled ? 'modify' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 4,
	},
	views: {
		label: i18n.t('i18n.views'),
		matrix: permissionsV2Enabled ? 'download' : undefined,
		userLevel: permissionsV2Enabled ? undefined : 2,
	},
};

export default {
	constituents,
	dragUserLevel,
	importTasks,
	renderableChanges,
	status,
	things,
};
